import React from "react";
import PageShell from "@/components/PageShell";
import { useSettings } from "@/context/SettingsContext";

export function AboutPage() {
  const { settings } = useSettings();
  return (
    <PageShell>
      <section className="max-w-3xl mx-auto px-6 py-20">
        <div className="font-mystic text-rose-400 text-sm tracking-widest">創立の書</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white tracking-tight mt-2">About Kyouka Reimei TL</h1>
        <p className="mt-6 font-mystic italic text-xl text-zinc-300">{settings.tagline}</p>
        <div className="mt-8 prose-mystic">
          <p>{settings.about_text}</p>
          <p>
            We translate visual novels, RPGs, and obscure Japanese games with care—preserving voice, nuance, and the
            mystical pull of the original. Our patrons fuel the work: every coin of tribute is invested back into
            scripts, editing, art, and distribution.
          </p>
          <h2>Why &ldquo;Kyouka Reimei&rdquo;?</h2>
          <p>
            <span className="font-mystic text-rose-300">鏡花黎明</span> — &ldquo;Mirror-Flower, Crimson Dawn&rdquo; — a vision both
            illusory and breathtaking. Our work is the same: ephemeral, devotional, and ablaze with new possibility.
          </p>
        </div>
      </section>
    </PageShell>
  );
}

export function ContactPage() {
  const { settings } = useSettings();
  const DISCORD_URL = "https://discord.gg/fDK3f3WAWg";
  return (
    <PageShell>
      <section className="max-w-2xl mx-auto px-6 py-20">
        <div className="font-mystic text-rose-400 text-sm tracking-widest">交信</div>
        <h1 className="font-display text-4xl font-black text-white tracking-tight mt-2">Contact the Order</h1>
        <p className="mt-4 text-zinc-400 font-mystic italic">
          For support, reach us directly on Discord.
        </p>
        <div className="mt-8 glass-strong rounded-xl p-8 sm:p-10 text-center">
          <div className="w-16 h-16 mx-auto rounded-2xl bg-gradient-to-br from-rose-600 to-violet-700 grid place-items-center pulse-glow">
            <svg viewBox="0 0 24 24" className="w-9 h-9 text-white" fill="currentColor" aria-hidden="true">
              <path d="M20.317 4.369A19.79 19.79 0 0 0 16.558 3l-.197.346a17.99 17.99 0 0 0-5.722 0L10.442 3a19.79 19.79 0 0 0-3.76 1.369C2.96 9.6 2.014 14.682 2.49 19.68a19.93 19.93 0 0 0 5.66 2.79l.495-.79c-.835-.318-1.61-.7-2.33-1.158l.516-.382c4.234 1.926 9.105 1.926 13.286 0l.516.382a14.4 14.4 0 0 1-2.33 1.158l.494.79a19.93 19.93 0 0 0 5.66-2.79c.548-5.85-.78-10.886-3.74-15.31zM8.02 16.43c-1.18 0-2.156-1.058-2.156-2.36 0-1.305.962-2.362 2.156-2.362 1.21 0 2.18 1.07 2.157 2.36 0 1.304-.962 2.362-2.157 2.362zm7.974 0c-1.18 0-2.156-1.058-2.156-2.36 0-1.305.962-2.362 2.156-2.362 1.205 0 2.18 1.07 2.156 2.36 0 1.304-.95 2.362-2.156 2.362z" />
            </svg>
          </div>
          <h2 className="font-display text-2xl font-bold text-white mt-5">Join our Discord</h2>
          <p className="text-sm text-zinc-400 mt-2 font-mystic italic max-w-sm mx-auto">
            All support, questions, and tribute issues are handled in our Discord server. Click below to enter.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-7">
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3.5 rounded-md bg-[#5865F2] hover:bg-[#4752c4] text-white font-display font-bold tracking-wide shadow-[0_0_25px_rgba(88,101,242,0.45)] transition-all hover:shadow-[0_0_35px_rgba(88,101,242,0.7)] hover:-translate-y-0.5"
              data-testid="contact-discord-btn"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
                <path d="M20.317 4.369A19.79 19.79 0 0 0 16.558 3l-.197.346a17.99 17.99 0 0 0-5.722 0L10.442 3a19.79 19.79 0 0 0-3.76 1.369C2.96 9.6 2.014 14.682 2.49 19.68a19.93 19.93 0 0 0 5.66 2.79l.495-.79c-.835-.318-1.61-.7-2.33-1.158l.516-.382c4.234 1.926 9.105 1.926 13.286 0l.516.382a14.4 14.4 0 0 1-2.33 1.158l.494.79a19.93 19.93 0 0 0 5.66-2.79c.548-5.85-.78-10.886-3.74-15.31zM8.02 16.43c-1.18 0-2.156-1.058-2.156-2.36 0-1.305.962-2.362 2.156-2.362 1.21 0 2.18 1.07 2.157 2.36 0 1.304-.962 2.362-2.157 2.362zm7.974 0c-1.18 0-2.156-1.058-2.156-2.36 0-1.305.962-2.362 2.156-2.362 1.205 0 2.18 1.07 2.156 2.36 0 1.304-.95 2.362-2.156 2.362z" />
              </svg>
              Discord Server
            </a>
            <a
              href="https://www.facebook.com/KyoukaReimei02"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3.5 rounded-md bg-[#1877F2] hover:bg-[#166fe5] text-white font-display font-bold tracking-wide shadow-[0_0_25px_rgba(24,119,242,0.45)] transition-all hover:shadow-[0_0_35px_rgba(24,119,242,0.7)] hover:-translate-y-0.5"
              data-testid="contact-facebook-btn"
            >
              <svg viewBox="0 0 24 24" className="w-5 h-5" fill="currentColor" aria-hidden="true">
                <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
              </svg>
              Facebook Founder
            </a>
          </div>
          <div className="mt-6 text-xs text-zinc-500">
            We answer on Discord & Facebook — the order is always listening.
          </div>
        </div>
      </section>
    </PageShell>
  );
}
